import React, { ComponentProps, useState } from 'react'
import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { NonCollapsibleMenu } from '../NonCollapsibleMenu'
import { useMyAccountMenu } from '../../hooks/useMyAccountMenu'
import {
  MobileMenuRoot,
  Content,
  MobileMenuTrigger,
  MobileMenuContent,
  MyAccountLink,
} from './MobileMenu.styles'

type MobileMenuOwnProps = ComponentProps<typeof MobileMenuRoot>
export type MobileMenuProps = MobileMenuOwnProps & {
  isScrollingDown: boolean
  setIsOpen: (isOpen: boolean) => void
  isOpen: boolean
}

export const MobileMenu = ({ isScrollingDown, setIsOpen, isOpen, ...props }: MobileMenuProps) => {
  const { t } = useTranslation()
  const { menuSections, activeSection } = useMyAccountMenu()

  const iconName: IconName = isOpen ? 'arrow-up-line' : 'arrow-down-line'

  return (
    <MobileMenuRoot isOpen={isOpen} isScrollingDown={isScrollingDown} {...props}>
      <Content onOpenChange={() => setIsOpen(!isOpen)} defaultOpen={false}>
        <MobileMenuTrigger>
          <Text size="headline" weight="semiBold">
            {activeSection}
          </Text>
          <Icon name={iconName} />
        </MobileMenuTrigger>
        <MobileMenuContent>
          <Stack gap="2" direction="column">
            <MyAccountLink active={activeSection === t('my-account:menu-title')}>
              <Link href="/user" passHref>
                <Text as="a" size="headline" weight="semiBold">
                  {t('my-account:menu-title')}
                </Text>
              </Link>
            </MyAccountLink>
            {menuSections.map(({ title, ...rest }) => (
              <NonCollapsibleMenu
                activeSection={activeSection}
                key={title}
                title={title}
                {...rest}
              />
            ))}
          </Stack>
        </MobileMenuContent>
      </Content>
    </MobileMenuRoot>
  )
}

MobileMenu.displayName = 'MobileMenu'
